import { z } from 'zod';
/**
 * Контракт /health. Демонстрирует главный смысл пакета shared:
 * эта схема используется и сервером при формировании ответа,
 * и фронтендом при его разборе. Рассинхрон между ними невозможен.
 */
export const healthStatusSchema = z.enum(['ok', 'degraded', 'down']);
export const dependencyHealthSchema = z.object({
    name: z.string(),
    status: healthStatusSchema,
    latencyMs: z.number().nonnegative().nullable(),
    error: z.string().nullable(),
});
/**
 * Предупреждение: система работает, но какая-то настройка бездействует.
 *
 * Отдельно от `dependencies` намеренно. Зависимость упала — система не
 * работает, и это видно сразу. А бездействующая настройка выглядит
 * работающей: ручка на месте, значение сохраняется, версия создаётся —
 * и ничего не происходит. Такое не находят, пока не станет поздно,
 * поэтому оно должно быть написано на экране прямым текстом.
 */
export const healthWarningSchema = z.object({
    /** Для кода: по нему предупреждение узнаётся, не разбирая текст. */
    code: z.string(),
    /** Для человека: что именно не работает. */
    text: z.string(),
    /** Для человека: что с этим сделать. */
    fix: z.string(),
});
export const healthResponseSchema = z.object({
    status: healthStatusSchema,
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    checkedAt: z.iso.datetime(),
    dependencies: z.array(dependencyHealthSchema),
    warnings: z.array(healthWarningSchema).default([]),
});
//# sourceMappingURL=health.js.map